import {Container as MantineContainer} from '@mantine/core';

/**
 * Max-width page container — design-layer pass-through over Mantine `Container`.
 * @registry Pass-through Mantine Container; import this instead of @mantine/core outside src/design.
 */
export const Container = MantineContainer;
